import { resourceExplorerStateSelector } from "./resourceExplorerStateSelector";
import { RootState } from "../../store";

export const resourceExplorerSearchSelector = (state: RootState): string => {
  return resourceExplorerStateSelector(state).search;
};
